var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item',{attrs:{"dense":""}},[_c('v-list-item-content',[_c('v-list-item-title',{staticClass:"primary--text",staticStyle:{"pointer-events":"none"}},[_vm._v(" "+_vm._s(_vm.title)+" ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }